import React from 'react'

import { Jump } from '~/components/elements/Jump'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import { useSelectedBrands } from '../hooks/useSelectedBrands'

export const SelectedBrandList = () => {
  const selectedBrands = useSelectedBrands()

  if (selectedBrands.length === 0) {
    return null
  }

  return (
    <VStack align="start" inline={true} spacing={0}>
      {selectedBrands.map((brand) => (
        <Jump key={brand.id} hash={brand.id}>
          <Typography variant="heading2">{brand.name}</Typography>
        </Jump>
      ))}
    </VStack>
  )
}
